/* ─────────────────────────────────────────────────────────────────────────
   KIMDYMA · eb-cart.js — the cart conversation. v4.1

   Hand-written; replaces the generated eb-shop.js, whose maths were DOM-local
   (a prototype that never called Shopify) and whose copy was hard-coded.

   ONE SOURCE OF TRUTH: /cart.js. Every mutation posts, then repaints from the
   response — never from what the page hoped would happen. An optimistic UI
   that guesses wrong shows a customer a total they will not be charged.

   The drawer and the cart page are re-rendered from the CART SECTIONS API, so
   the markup a mutation produces is the same Liquid that rendered the page.
   No second templating layer in JS, and nothing to drift.

   Everything is additive: with this file removed every stepper is still a
   number input in a form, remove is still a button, and add-to-cart still
   posts and lands on /cart.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.ebCartLoaded) return;
  window.ebCartLoaded = true;

  var slice = function (l) { return Array.prototype.slice.call(l); };
  var routes = window.ebRoutes || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 金额照店铺后台的货币格式写（<html data-money-format>，即 Liquid money 用的那一套），
     脚本算出来的合计和页面上 Liquid 印的价格才是同一种写法：之前用浏览器的
     Intl 英文格式，页面写「€1.400,00」、脚本算出来写「€1,400.00」。
     读不到格式时才退回 Intl。 */
  function money(cents) {
    var fmt = document.documentElement.getAttribute('data-money-format');
    var n = Math.round(Number(cents) || 0);
    if (fmt && /\{\{\s*\w+\s*\}\}/.test(fmt)) {
      var group = function (num, dec, thou, sep) {
        var parts = (num / 100).toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return parts[0] + (parts[1] ? sep + parts[1] : '');
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        switch (k) {
          case 'amount_no_decimals': return group(n, 0, ',', '.');
          case 'amount_with_comma_separator': return group(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
          case 'amount_with_space_separator': return group(n, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return group(n, 0, ' ', ',');
          default: return group(n, 2, ',', '.');
        }
      });
    }
    var locale = document.documentElement.lang || 'en';
    var currency = document.documentElement.dataset.currency || 'EUR';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(n / 100); }
    catch (e) { return (n / 100).toFixed(2); }
  }
  window.ebMoney = money;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }
  function busy(el, on) {
    if (!el) return;
    el.toggleAttribute('disabled', !!on);
    el.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* ── repaint ─────────────────────────────────────────────────────────────
     The badge and the totals come from the cart object; the drawer's body and
     the cart page's lines come from the Section Rendering API, so their markup
     is the section's own Liquid rather than a JS copy of it. */
  var SECTIONS = ['cart-drawer', 'main-cart'];
  function paintCart(cart) {
    slice(document.querySelectorAll('[data-eb-cart-count]')).forEach(function (b) {
      b.textContent = cart.item_count;
      b.hidden = cart.item_count === 0;
      b.classList.toggle('is-live', cart.item_count > 0);
      b.classList.remove('is-bumped'); void b.offsetWidth; b.classList.add('is-bumped');
    });
    slice(document.querySelectorAll('[data-eb-cart-count-label]')).forEach(function (l) {
      l.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    });
    slice(document.querySelectorAll('[data-eb-cart-total]')).forEach(function (t) { t.textContent = money(cart.total_price); });
    document.dispatchEvent(new CustomEvent('eb:cart:update', { detail: cart }));
  }
  function refreshSections() {
    var ids = SECTIONS.filter(function (id) { return document.querySelector('#shopify-section-' + id + ', [data-eb-section="' + id + '"]'); });
    // The drawer is a snippet rendered by the layout, so it has no section to
    // ask for; reload the cart page's section only where one exists.
    if (!ids.length) return Promise.resolve();
    return fetch('?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        Object.keys(data).forEach(function (id) {
          var host = document.querySelector('#shopify-section-' + id);
          if (!host) return;
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.querySelector('#shopify-section-' + id);
          if (fresh) host.innerHTML = fresh.innerHTML;
        });
      }).catch(function () {});
  }
  function reloadDrawer() {
    // The drawer lives outside every section. Fetching /cart and lifting its
    // own drawer out is cheaper than inventing a second renderer for it.
    var drawer = document.querySelector('[data-eb-cart-drawer]');
    if (!drawer) return Promise.resolve();
    return fetch(routes.cart || '/cart', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-eb-cart-drawer]');
        if (!fresh) return;
        var wasOpen = drawer.open;
        drawer.innerHTML = fresh.innerHTML;
        if (wasOpen) drawer.classList.add('is-open');
      }).catch(function () {});
  }
  function afterMutation(cart) {
    paintCart(cart);
    return Promise.all([refreshSections(), reloadDrawer()]);
  }

  /* ── quantity ────────────────────────────────────────────────────────── */
  function change(key, qty, el) {
    busy(el, true);
    return post(routes.cartChange || '/cart/change.js', { id: key, quantity: qty })
      .then(afterMutation)
      .catch(function () { window.location.href = routes.cart || '/cart'; })
      .finally(function () { busy(el, false); });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-eb-qty-up],[data-eb-qty-down]');
    if (step) {
      var line = step.closest('[data-eb-line]');
      var input = step.closest('[data-eb-qty]').querySelector('[data-eb-qty-input]');
      var next = (parseInt(input.value, 10) || 0) + (step.hasAttribute('data-eb-qty-up') ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      if (line) change(line.getAttribute('data-key'), next, step);
      return;
    }
    var rm = e.target.closest('[data-eb-line-remove]');
    if (rm) {
      var l = rm.closest('[data-eb-line]');
      if (l) change(l.getAttribute('data-key'), 0, rm);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-eb-qty-input]');
    if (!input) return;
    var line = input.closest('[data-eb-line]');
    if (line) change(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0), input);
  });

  /* ── the button says what happened ───────────────────────────────────────
     Adding… while the request is out, then Added ✓ for two seconds, then
     back. The words come from the confirmation panel's attributes, so with
     the panel switched off the button simply stays as it was — and its width
     never changes, so nothing beside it moves. */
  function atcPanel() { return document.querySelector('[data-eb-atc]'); }
  function buttonState(btn, state) {
    if (!btn) return;
    var panel = atcPanel();
    window.clearTimeout(btn._ebStateTimer);
    if (state === 'adding') {
      if (btn.classList.contains('is-added') && btn._ebLabel != null) btn.innerHTML = btn._ebLabel;
      btn._ebLabel = btn.innerHTML;
      btn.classList.remove('is-added');
      btn.classList.add('is-adding');
      if (panel && panel.dataset.adding) btn.textContent = panel.dataset.adding;
    } else if (state === 'added') {
      btn.classList.remove('is-adding');
      if (!panel || !panel.dataset.added) { buttonState(btn, 'idle'); return; }
      btn.classList.add('is-added');
      btn.textContent = '';
      var tick = panel.querySelector('.eb-atc__ok svg');
      if (tick) btn.appendChild(tick.cloneNode(true));
      btn.appendChild(document.createTextNode(panel.dataset.added));
      btn._ebStateTimer = window.setTimeout(function () { buttonState(btn, 'idle'); }, 2000);
    } else {
      btn.classList.remove('is-adding', 'is-added');
      if (btn._ebLabel != null) btn.innerHTML = btn._ebLabel;
      btn._ebLabel = null;
    }
  }

  /* ── when it could not go in, say why, beside the button ────────────────
     Shopify answers a refused add with a sentence of its own — "You can only
     add 1 of this item" — and that sentence is better than anything written
     here, so it is printed as it arrives, above the button that was pressed.
     No panel, no drawer: nothing went in. A network failure has no sentence,
     and falls back to posting the form the ordinary way. */
  function clearError(scope) {
    slice((scope || document).querySelectorAll('[data-eb-atc-error]')).forEach(function (n) { n.remove(); });
  }
  function showError(form, button, text) {
    var panel = atcPanel();
    var box = document.createElement('div');
    box.className = 'eb-alert eb-alert--danger eb-atc-error';
    box.setAttribute('role', 'alert');
    box.setAttribute('data-eb-atc-error', '');
    box.textContent = (panel && panel.dataset.notAdded ? panel.dataset.notAdded + ' ' : '') + text;
    var host = button ? (button.closest('.eb-buy__actions') || button) : form.lastElementChild;
    if (host && host.parentNode) host.parentNode.insertBefore(box, host);
  }
  document.addEventListener('eb:variant', function () { clearError(); });

  /* ── add to cart ─────────────────────────────────────────────────────────
     A campaign card announces its selected accessories on the form; they are
     posted in the same request so the bundle arrives as one purchase, and the
     bike's title is written onto each as a property so the cart can indent
     them under it. */
  var pendingExtras = null;
  document.addEventListener('eb:cart:extras', function (e) { pendingExtras = e.detail.items; });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-eb-add]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var data = new FormData(form);
    var title = (form.closest('[data-eb-pcard], [data-eb-buy]') || {}).querySelector
      ? (form.closest('[data-eb-pcard], [data-eb-buy]').querySelector('.eb-pcard__title, .eb-buy__title') || {}).textContent : '';
    title = (title || '').trim();

    /* Line properties the form carries — properties[Frame number] on a
       warranty — go with the line. Without this the fetch path posted id and
       quantity only, and a cover arrived in the cart with no frame on it. */
    var first = { id: data.get('id'), quantity: parseInt(data.get('quantity'), 10) || 1 };
    var props = {};
    data.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && String(value).trim() !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) first.properties = props;
    var items = [first];
    if (pendingExtras && pendingExtras.length) {
      pendingExtras.forEach(function (x) {
        items.push({ id: x.id, quantity: x.quantity, properties: title ? { _bundled_with: title } : undefined });
      });
    }
    pendingExtras = null;

    clearError(form);
    buttonState(button, 'adding');
    busy(button, true);
    var added = [];
    post(routes.cartAdd || '/cart/add.js', { items: items })
      .then(function (res) {
        added = res && res.items ? res.items : (res ? [res] : []);
        return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        busy(button, false);
        buttonState(button, 'added');
        /* An add made from INSIDE the open drawer needs no confirmation panel:
           the drawer has already redrawn with the line in it, and a small panel
           on top of the thing that just answered the question is noise. */
        var inDrawer = !!form.closest('[data-eb-cart-drawer]');
        return afterMutation(cart).then(function () { if (!inDrawer) confirm(added, items, cart); });
      })
      .catch(function (err) {
        busy(button, false);
        buttonState(button, 'idle');
        if (err && err.status && (err.description || err.message)) {
          showError(form, button, err.description || err.message);
          return;
        }
        form.submit();
      });
  });

  /* ── the confirmation ────────────────────────────────────────────────────
     Built from the cart AFTER the add, matched by line key, so every price in
     it is one Shopify will charge. A line that was already in the cart shows
     only what this press added to it. What the bundle saved is the cart's own
     discount on those lines; with none, the line is not drawn. */
  var ATC_MS = 6000;
  var atc = { timer: null, left: 0, started: 0, hovered: false };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function thumb(src, size) {
    var m = el('span', 'eb-atc__media');
    if (src) {
      var img = document.createElement('img');
      img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + 'x$1$2');
      img.alt = ''; img.loading = 'lazy';
      m.appendChild(img);
    }
    return m;
  }

  function confirm(added, requested, cart) {
    var panel = atcPanel();
    if (!panel) { if (window.ebOverlay) window.ebOverlay.open(document.getElementById('EbCart')); return; }

    var want = {};
    requested.forEach(function (r) { want[String(r.id)] = (want[String(r.id)] || 0) + (r.quantity || 1); });
    var lines = added.map(function (a) {
      var line = cart.items.filter(function (i) { return i.key === a.key; })[0] || a;
      var qty = want[String(a.variant_id || a.id)] || a.quantity || 1;
      var each = line.quantity ? line.final_line_price / line.quantity : (line.final_price || 0);
      var eachWas = line.quantity ? line.original_line_price / line.quantity : (line.original_price || each);
      return { item: line, qty: qty, price: Math.round(each * qty), was: Math.round(eachWas * qty) };
    });
    if (!lines.length) return;

    var box = panel.querySelector('[data-eb-atc-line]');
    if (box) {
      box.textContent = '';
      var lead = lines[0], extras = lines.slice(1);
      var addedTotal = lines.reduce(function (s, l) { return s + l.price; }, 0);

      var row = el('div', 'eb-atc__row');
      row.appendChild(thumb(lead.item.image, 160));
      var d = el('span', 'eb-atc__detail');
      d.appendChild(el('span', 'eb-atc__name', lead.item.product_title || lead.item.title));
      var metaBits = [];
      if (lead.item.variant_title && lead.item.variant_title !== 'Default Title') metaBits.push(lead.item.variant_title);
      if (lead.qty > 1) metaBits.push('× ' + lead.qty);
      var meta = el('span', 'eb-atc__meta', metaBits.join(' · '));
      if (extras.length) {
        /* the phone's fold: the accessories become words on the bike's line */
        meta.appendChild(el('em', 'eb-atc__plus', (metaBits.length ? ' · ' : '') + '+ ' +
          extras.map(function (x) { return x.item.product_title || x.item.title; }).join(', ')));
      }
      d.appendChild(meta);
      row.appendChild(d);
      var p = el('span', 'eb-atc__price');
      p.appendChild(el('span', 'eb-atc__one', money(lead.price)));
      p.appendChild(el('span', 'eb-atc__all', money(addedTotal)));
      row.appendChild(p);
      box.appendChild(row);

      extras.forEach(function (x) {
        var r = el('div', 'eb-atc__row eb-atc__row--sub');
        r.appendChild(thumb(x.item.image, 96));
        var dd = el('span', 'eb-atc__detail');
        dd.appendChild(el('span', 'eb-atc__name', x.item.product_title || x.item.title));
        dd.appendChild(el('span', 'eb-atc__meta', panel.dataset.with || ''));
        r.appendChild(dd);
        var pr = el('span', 'eb-atc__price', money(x.price));
        if (x.was > x.price) pr.appendChild(el('s', null, money(x.was)));
        r.appendChild(pr);
        box.appendChild(r);
      });
    }

    var saved = lines.reduce(function (s, l) { return s + Math.max(0, l.was - l.price); }, 0);
    var saveRow = panel.querySelector('[data-eb-atc-save]');
    if (saveRow) {
      saveRow.hidden = saved <= 0;
      var sv = panel.querySelector('[data-eb-atc-saved]');
      if (sv) sv.textContent = money(saved);
    }
    var tpl = panel.dataset.countTpl || '[n]';
    var countText = tpl.replace('[n]', cart.item_count);
    var items = panel.querySelector('[data-eb-atc-items]');
    if (items) items.textContent = countText;
    var count = panel.querySelector('[data-eb-atc-count]');
    if (count) count.textContent = countText;
    var total = panel.querySelector('[data-eb-atc-total]');
    if (total) total.textContent = money(cart.total_price);

    openAtc(panel);
  }

  /* THE CARET POINTS AT THE ICON. Measured, because the icon's place depends
     on the header's layout, the logo and the width. A header that hid itself
     on the way down is brought back, or the caret points at nothing. */
  function place(panel) {
    var header = document.querySelector('[data-eb-header]');
    if (header) header.classList.remove('is-hidden');
    var icon = slice(document.querySelectorAll('.eb-cart-btn')).filter(function (b) { return b.offsetParent; })[0];
    if (!icon) { panel.classList.remove('has-caret'); return; }
    var r = icon.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var right = Math.max(10, Math.round(vw - r.right - 4));
    panel.style.setProperty('--atc-right', right + 'px');
    panel.classList.add('has-caret');
    /* the caret's own offset is read after the phone rule has had its say
       about the panel's right edge */
    window.requestAnimationFrame(function () {
      var pr = panel.getBoundingClientRect();
      var caret = Math.round(pr.right - (r.left + r.width / 2) - 6);
      panel.style.setProperty('--atc-caret', Math.max(12, caret) + 'px');
    });
    icon.classList.remove('is-ringing'); void icon.offsetWidth; icon.classList.add('is-ringing');
  }

  function openAtc(panel) {
    place(panel);
    var bar = panel.querySelector('.eb-atc__timer i');
    if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; }
    panel.hidden = false;
    void panel.offsetWidth;
    panel.classList.add('is-open');
    atc.hovered = panel.matches(':hover');
    if (reduce.matches) { window.clearTimeout(atc.timer); atc.timer = null; return; }
    if (bar) bar.classList.add('is-run');
    arm(ATC_MS);
    if (atc.hovered) pause();
  }
  function arm(ms) {
    var panel = atcPanel();
    window.clearTimeout(atc.timer);
    atc.left = ms; atc.started = Date.now();
    atc.timer = window.setTimeout(dismissAtc, ms);
    if (panel) panel.classList.remove('is-paused');
  }
  function pause() {
    var panel = atcPanel();
    if (!atc.timer) return;
    window.clearTimeout(atc.timer);
    atc.timer = null;
    atc.left = Math.max(0, atc.left - (Date.now() - atc.started));
    if (panel) panel.classList.add('is-paused');
  }
  function resume() {
    var panel = atcPanel();
    if (atc.timer || reduce.matches || !panel || panel.hidden || !panel.classList.contains('is-open')) return;
    if (atc.hovered || panel.contains(document.activeElement)) return;
    arm(Math.max(1200, atc.left));
  }
  function dismissAtc() {
    var panel = atcPanel();
    window.clearTimeout(atc.timer);
    atc.timer = null;
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open', 'is-paused');
    window.setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, reduce.matches ? 0 : 420);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-eb-atc-close]') || e.target.closest('[data-eb-atc] [data-eb-open]')) dismissAtc();
  });
  document.addEventListener('keydown', function (e) {
    var panel = atcPanel();
    if (e.key === 'Escape' && panel && !panel.hidden) dismissAtc();
  });
  /* HOVER, FOCUS AND A THUMB HOLDING IT all stop the clock; leaving starts it
     again with what was left. */
  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest || !e.target.closest('[data-eb-atc]') || atc.hovered) return;
    atc.hovered = true; pause();
  });
  document.addEventListener('mouseout', function (e) {
    var panel = atcPanel();
    if (!panel || !atc.hovered || panel.contains(e.relatedTarget)) return;
    if (!e.target.closest || !e.target.closest('[data-eb-atc]')) return;
    atc.hovered = false; resume();
  });
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('[data-eb-atc]')) pause(); });
  document.addEventListener('focusout', function (e) {
    var panel = atcPanel();
    if (panel && e.target.closest && e.target.closest('[data-eb-atc]') && !panel.contains(e.relatedTarget)) {
      window.setTimeout(resume, 0);
    }
  });

  /* On a phone the card hangs from the header, so it leaves the way it came:
     a flick upward. A hold stops the clock like a hover does. */
  var swipe = null;
  document.addEventListener('touchstart', function (e) {
    var panel = e.target.closest && e.target.closest('[data-eb-atc]');
    if (!panel) return;
    swipe = { y: e.touches[0].clientY };
    pause();
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!swipe) return;
    if (e.touches[0].clientY - swipe.y < -36) { swipe = null; dismissAtc(); }
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!swipe) return;
    swipe = null;
    window.setTimeout(resume, 0);
  });

  /* ── toast ───────────────────────────────────────────────────────────── */
  window.ebToast = function (text) {
    var t = document.querySelector('[data-eb-toast]');
    if (!t) return;
    var span = t.querySelector('[data-eb-toast-text]');
    if (span) span.textContent = text;
    t.hidden = false; void t.offsetWidth; t.classList.add('is-open');
    window.setTimeout(function () {
      t.classList.remove('is-open');
      window.setTimeout(function () { t.hidden = true; }, 320);
    }, 2600);
  };

  /* ── order note ──────────────────────────────────────────────────────── */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-eb-note]');
    if (!note) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      post('/cart/update.js', { note: note.value }).catch(function () {});
    }, 700);
  });

  /* ── consent ─────────────────────────────────────────────────────────────
     The choice gates Shopify's own Customer Privacy API, not just this bar.
     Rejecting is one press, exactly like accepting. */
  var consent = document.querySelector('[data-eb-consent]');
  if (consent) {
    var KEY = 'eb-consent';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (err) {}
    if (!stored) window.setTimeout(function () { consent.hidden = false; void consent.offsetWidth; consent.classList.add('is-open'); }, 800);
    consent.addEventListener('click', function (e) {
      var b = e.target.closest('[data-eb-consent-choice]');
      if (!b) return;
      var all = b.getAttribute('data-eb-consent-choice') === 'all';
      try { localStorage.setItem(KEY, all ? 'all' : 'essential'); } catch (err) {}
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({ analytics: all, marketing: all, preferences: all, sale_of_data: all }, function () {});
      }
      consent.classList.remove('is-open');
      window.setTimeout(function () { consent.hidden = true; }, 320);
    });
  }
  window.ebResetConsent = function () {
    try { localStorage.removeItem('eb-consent'); } catch (err) {}
    if (consent) { consent.hidden = false; consent.classList.add('is-open'); }
  };
})();
